import { Progress } from '@atom/mui';
import { UserDetail } from '@atom/types/user';

import UserRow from './UserRow';

import classes from './usersTab.module.css';

interface Props {
  users: UserDetail[];
  loading: boolean;
  errors: any;
}

const UsersList = ({ users, loading, errors }: Props) => (
  <div className={classes.usersList}>
    {users.map((user: UserDetail) => (
      <UserRow key={user.id} user={user} />
    ))}
    {(loading || errors) && <Progress />}
  </div>
);

export default UsersList;
